import React from 'react';
import { BOAT, SAILBOAT, CATAMARAN, JON_BOAT } from 'constants/boatApplication';

/**
 * Components
 */
import { Input } from 'Components/Input';
import Slider from 'Components/Slider';
import { CalculatedOutput } from 'Components/CalculatedOutput';

class CubicCapacityInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      calculationLengthError: null,
      volumeWithinMotorError: null,
      cubicCapacityError: null,
      areaPictureStyle: 'default-picture',
    };

    this.tableColumns = Object.keys(props.areaTypes).sort();
  }

  showSelectedAreaPicture = areaStyleName => () => {
    this.setState({areaPictureStyle: areaStyleName});
  };

  showDefaultAreaPicture = () => {
    this.setState({areaPictureStyle: 'default-picture'});
  };

  getManualInputField = () => {
    const {cubicCapacity, handleInputChange} = this.props;

    return (
      <React.Fragment>
        <header>Boat Capacity Data</header>
        <Input
          isNumeric
          mainWrapperClassName='input__main-wrapper_primary'
          inputClassName='input__input-field_primary'
          label='Cubic Capacity *'
          error={this.isError('cubicCapacity')}
          value={cubicCapacity}
          onChange={handleInputChange('cubicCapacity')}
          units='Cu. Ft.'
        />
      </React.Fragment>
    );
  };

  isError = (field, subField) => {
    return subField ? this.props.errors[field] && this.props.errors[field][subField] : this.props.errors[field];
  };

  getMatrixInputField = () => {
    const {
      areas, calculationLength, volumeWithinMotor, cubicCapacity, handleInputChange, handleMatrixChange,
      isAreas, toggleAreasInput, tableRows, boat, isEmptyInputs
    } = this.props;

    const {areaPictureStyle} = this.state;
    const getAreaPictureTypeStyle = boatType => {
      if (boat.boatType === BOAT || boatType === SAILBOAT) return 'boat';
      if (boat.boatType === CATAMARAN) return 'catamaran';
      if (boat.boatType === JON_BOAT) return 'jonboat';
    };

    return (
      <React.Fragment>
        <header>
          Boat Capacity Data
          <Slider state={isAreas} label='Areas Only' onLabel='On' offLabel='Off' toggleAction={toggleAreasInput} />
        </header>

        {(boat.boatType === BOAT ||
          boat.boatType === SAILBOAT ||
          boat.boatType === CATAMARAN ||
          boat.boatType === JON_BOAT) && (
            <div className={`area-picture ${getAreaPictureTypeStyle(boat.boatType)} ${areaPictureStyle}`} />
          )}

        <div className='table-wrapper'>
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Dimensions</th>
                <th>Eight Length Fwd (AA)</th>
                <th>Quarter Length FWD (A)</th>
                <th>Amid Ships (B)</th>
                <th>Quarter Length Alt (C)</th>
                <th>Transom (D)</th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map(rowName => (
                <tr className={isAreas ? 'hidden' : ''} key={rowName}>
                  <td>{rowName === 'beam' ? 'Full Beam' : rowName}</td>
                  {this.tableColumns.map(columnName => (
                    <td
                      key={columnName}
                      className={
                        this.isError([columnName], [rowName])
                          ? 'invalid-cell'
                          : `${columnName}  ${rowName} ${this.props.errors}  ${this.props.errors[columnName]}  ${
                            this.props.errors[columnName] ? this.props.errors[columnName][rowName] : 'none'
                          }`
                      }
                    >
                      <Input
                        isNumeric
                        unitsTop={10}
                        inputClassName='_height_pc_100 _width_pc_100'
                        inputFieldWrapperClassName='_height_pc_100 _width_pc_100'
                        value={areas[columnName][rowName]}
                        onChange={handleMatrixChange(columnName, rowName)}
                        onBlur={this.showDefaultAreaPicture}
                        onFocus={this.showSelectedAreaPicture(columnName)}
                        units='In.'
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>{this.getAreaTableRow()}</tfoot>
          </table>
        </div>

        <header>Cubic Capacity Data</header>
        <Input
          isNumeric
          mainWrapperClassName='input__main-wrapper_primary _margin_right_30'
          inputClassName='input__input-field_primary'
          label='Calculation Length *'
          error={this.isError('calculationLength')}
          value={calculationLength}
          onChange={handleInputChange('calculationLength')}
          units='In.'
        />
        <Input
          isNumeric
          mainWrapperClassName='input__main-wrapper_primary'
          inputClassName='input__input-field_primary'
          label='Volume Within Motor *'
          error={this.isError('volumeWithinMotor')}
          value={volumeWithinMotor}
          onChange={handleInputChange('volumeWithinMotor')}
          units='Cu. In.'
        />
        <CalculatedOutput
          label='Calculated Cubic Capacity'
          value={isEmptyInputs() ? cubicCapacity : ''}
          units='Cu. Ft.'
        />
      </React.Fragment>
    );
  };

  getAreaTableRow = () => {
    const {areas, isAreas, handleAreaChange} = this.props;

    if (isAreas) {
      return (
        <tr>
          <td>Area</td>
          {this.tableColumns.map(columnName => (
            <td key={columnName} className={this.isError(columnName, 'area') ? 'error' : ''}>
              <Input
                isNumeric
                unitsTop={10}
                inputClassName='_height_pc_100 _width_pc_100'
                inputFieldWrapperClassName='_height_pc_100 _width_pc_100'
                value={areas[columnName].area !== undefined ? areas[columnName].area : ''}
                error={this.isError(columnName, 'area')}
                onChange={handleAreaChange(columnName, 'area')}
                onBlur={this.showDefaultAreaPicture}
                onFocus={this.showSelectedAreaPicture(columnName)}
                units='In.'
              />
            </td>
          ))}
        </tr>
      );
    }
    return (
      <tr className='output'>
        <td>Area</td>
        {this.tableColumns.map(columnName => (
          <td key={columnName}>
            {areas[columnName].area !== undefined ? (+areas[columnName].area).toFixed(2) + ' In.' : 'No data'}
          </td>
        ))}
      </tr>
    );
  };

  render() {
    const {isManual} = this.props;

    return (
      <section className={'scene_section cubic-capacity-input-section'}>
        {isManual ? this.getManualInputField() : this.getMatrixInputField()}
      </section>
    );
  }
}

export default CubicCapacityInput;



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/CubicCapacityScene/CubicCapacityInput.jsx